import React from 'react';
import styled from 'styled-components';
import { mediaQueries } from 'styles/utils/mediaQueries';
import CarouselHotelImages from 'components/carousel/CarouselHotelImages';
import HotDealsCarouselImage from 'components/carousel/HotDealsCarouselImage';

function HotDealsSliderComponent({ images }) {
  const items = images.map((image, index) => (
    <HotDealsCarouselImage small key={`hot-deal-image-${index}`} src={image.url} />
  ));

  return (
    <SliderWrap>
      <CarouselHotelImages items={items} />
    </SliderWrap>
  );
}

export default HotDealsSliderComponent;

const SliderWrap = styled.div`
  width: 245px;
  height: 100%;

  ${({ small }) =>
    small &&
    `
    width: 100%;
    height: 250px;
  `}

  ${mediaQueries.below.desktop`
		width: 100%;
		object-fit: cover;
  `}
`;
